// stores/appLink.ts
// ⚠️ DEPRECATED for server data: use per-route useAsyncData in layouts/pages.
// Kept as a small compatibility shim and a place for cross-page actions (e.g., power).

import { defineStore, acceptHMRUpdate } from 'pinia'

type VmId = number | string
export type PowerAction = 'reboot' | 'shutdown' | 'stop' | 'reset' | 'start'

export interface VmData {
    vmId?: VmId
    status?: string
    type?: string
    host?: string | null
    userId?: number
    invoiceId?: string
    node?: number
    locationId?: number
    operatingSystemId?: number
    cores?: number
    memory?: number
    disk?: number
    bandwidth?: number
    uplink?: number
    priceMonthly?: number
    expiryDate?: string | null
    createdAt?: string | null
    updatedAt?: string | null
    ipData: { ip: string; hostnames?: string[] }[]
}

const DEFAULT_VM: VmData = {
    vmId: undefined,
    status: '',
    type: '',
    host: null,
    userId: undefined,
    invoiceId: undefined,
    node: undefined,
    locationId: undefined,
    operatingSystemId: undefined,
    cores: 0,
    memory: 0,
    disk: 0,
    bandwidth: 0,
    uplink: 0,
    priceMonthly: 0,
    expiryDate: null,
    createdAt: null,
    updatedAt: null,
    ipData: [],
}

const authVersion = ref<number | null>(null)
const tokenAv = ref<number | null>(null)

function setAuthVersions(serverAv: number | null, jwtAv: number | null) {
    authVersion.value = serverAv
    tokenAv.value = jwtAv
}

function clearAuthVersions() {
    authVersion.value = null
    tokenAv.value = null
}

export const useAppLink = defineStore('link', () => {
    const vmData = reactive<VmData>({ ...DEFAULT_VM })

    return {
        navDrawer: null as null | boolean,
        themeDrawer: false,
        secureMainDrawer: null as null | boolean,
        secureAccountMenu: false,
        secureNotificationDialog: false,
        vmData,
        authVersion,
        tokenAv,
        setAuthVersions,
        clearAuthVersions,
    }
}, {
    persist: false as any
})

export type LinkStore = ReturnType<typeof useAppLink>

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAppLink, import.meta.hot))
}
